import { DemandSummaryReport } from "@/components/features/reports/Demands/DemandSummaryReport";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { demandSummaryQueryOptions } from "@/lib/data/react-query/reports/reports-demand-summary";
import type { DemandSummaryFilters } from "@/lib/data/requests/reports/reports-demand-summary";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { format } from "date-fns";

export const Route = createFileRoute("/_auth/reports/demand-summary")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();
  const canView = hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsDemands);
  const filters: DemandSummaryFilters = {
    asOfDate: format(new Date(), "yyyy-MM-dd"),
  };
  const query = useQuery({
    ...demandSummaryQueryOptions(filters),
    enabled: canView,
  });
  if (!canView) return <GlobalNotAuthorized />;
  return (
    <DemandSummaryReport
      report={query.data}
      isLoading={query.isLoading}
      isFetching={query.isFetching}
      isError={query.isError}
      onRetry={() => {
        void query.refetch();
      }}
    />
  );
}
